import {
  ConsentsEventParams,
  DataWarehouseEventType,
  DataWarehouseService,
  ModalCategory,
  ModalLabel,
} from "@identity/services";
import { inject, injectable, injectWithTransform } from "tsyringe";
import { WINDOW } from "@identity/symbols";
import { Logger, LoggerTransformer } from "@identity/utils";

@injectable()
export class OneTrustTracker {
  private ONETRUST_UI_SHOWN = "onetrust-ui-shown";
  private GA_CATEGORY: ModalCategory = "gdpr-modal-1t";
  constructor(
    @inject(WINDOW) private window: Window,
    @injectWithTransform(Logger, LoggerTransformer, "OneTrustTracker")
    private readonly logger: Logger,
    @inject(DataWarehouseService) private dataWarehouse: DataWarehouseService,
  ) {}

  init() {
    this.window.__tcfapi &&
      this.window.__tcfapi("addEventListener", 2, (tcdata: TcfResponse) => {
        if (tcdata?.eventStatus === "cmpuishown") {
          this.trackLoadTime();
          this.trackImpression();
        }

        if (tcdata?.eventStatus === "useractioncomplete") {
          const label: ModalLabel =
            tcdata.publisher.consents &&
            Object.keys(tcdata.publisher.consents).length > 0
              ? "accept"
              : "reject";
          this.trackAction(label);
        }
      });
  }

  private trackLoadTime() {
    this.dataWarehouse.track(
      DataWarehouseEventType.loadTime,
      this.ONETRUST_UI_SHOWN,
    );

    this.logger.info("Loading time tracking event sent");
  }

  private trackImpression() {
    const payload: ConsentsEventParams = {
      ga_category: this.GA_CATEGORY,
      ga_action: "impression",
      ga_label: "modal-view",
    };

    this.dataWarehouse.track(DataWarehouseEventType.consents, payload);

    this.logger.info("Impression tracking event sent");
  }

  private trackAction(label: ModalLabel) {
    const payload: ConsentsEventParams = {
      ga_category: this.GA_CATEGORY,
      ga_action: "click",
      ga_label: label,
    };

    this.dataWarehouse.track(DataWarehouseEventType.consents, payload);

    this.logger.info("Action tracking event sent", label);
  }
}
